import React from 'react';

import { usePlatformQuery } from '@dashboard/generated/wp/administrator';
import { Alert } from '@mui/material';

type Props = {
  platformId: string;
};
export default function PlatformDeletedAlert({ platformId }: Props) {
  const { data } = usePlatformQuery({ variables: { id: platformId } });
  const deletedAt = data?.Platform.deletedAt;
  if (!deletedAt) {
    return null;
  }
  return <Alert severity="warning">This platform was deleted on {new Date(deletedAt).toLocaleDateString()}.</Alert>;
}
